<script setup lang="ts">
import { timeAgo } from "@/modules/common";
import { Mate } from "@/types/entity";

defineProps<{
  mate?: Mate;
  title: string;
  desc: string;
  icon: string;
  dtCreate: string;
  isNeedAction: boolean;
}>();
</script>
<template>
  <div
    class="flex gap-2 justify-between"
    :class="{
      'text-primary-content': isNeedAction,
      'text-base-content': !isNeedAction,
    }"
  >
    <div class="flex gap-2">
      <UserAvatar class="h-10" :mate="mate" />
      <div class="flex flex-col gap-1 justify-items-stretch justify-between">
        <div>{{ title }}</div>
        <div
          class="flex gap-1 items-center text-xs"
          :class="{
            'text-primary-content/50': isNeedAction,
            'text-base-content/50': !isNeedAction,
          }"
        >
          <i :class="icon" />
          {{ desc }}
        </div>
      </div>
    </div>
    <div
      class="text-xs"
      :class="{
        'text-primary-content/50': isNeedAction,
        'text-base-content/50': !isNeedAction,
      }"
    >
      {{ timeAgo(dtCreate) }}
    </div>
  </div>
</template>
